<template>
    <mc-exercise-frame> 
        <div class="mc-layout-normal-container"> 
            <div class="mc-container">
                <output-frames :output-frames="outputFrames"></output-frames>
            </div>
        </div>
    </mc-exercise-frame> 
</template>

<script>
import McExerciseFrame from "../base/mc-exercise-frame.vue";
import OutputFrames from "../base/output/output-frames.vue";

export default {
  components: {
    McExerciseFrame,
    OutputFrames
  },
  computed: {
    outputFrames() {
      return this.$store.state.outputFrames;
    }
  }
};
</script>
 

<style scoped>
.mc-layout-normal-container {
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

@media (min-width: 900px) {
  .mc-container {
    max-width: 1000px; 
    margin: auto;
  }
}
@media (max-width: 900px) {
  .mc-container {
    min-width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
</style>